import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CONTEXT_MENU_DIRECTIVES, CoreModule } from '@alfresco/adf-core';
import { ContentModule } from '@alfresco/adf-content-services';
import { LocationLinkComponent } from '@adw/projects/aca-content/src/lib/components/common/location-link/location-link.component';
import { SearchInputComponent } from '@adw/projects/aca-content/src/lib/components/search/search-input/search-input.component';

import { WkDocumentListModule } from '../../forked/components/wk-document-list/wk-document-list.module';
import { WkSearchResultsRowComponent } from '../wk-search-results-row/wk-search-results-row.component';
import { AppInfoDrawerModule } from '@adw/projects/aca-content/src/lib/components/info-drawer/info.drawer.module';
import { WkSearchResultsComponent } from './wk-search-results.component';
import { WkAppLayoutModule } from '../../forked/components/layout/layout.module';
import {
  ToolbarActionComponent,
  ToolbarComponent,
  ContextActionsDirective,
} from '@adw/projects/aca-shared/src/public-api';
import { ThumbnailColumnComponent } from '@adw/projects/aca-content/src/lib/components/dl-custom-components/thumbnail-column/thumbnail-column.component';
import { SearchActionMenuComponent } from '@adw/projects/aca-content/src/lib/components/search/search-action-menu/search-action-menu.component';
import { EXTENSION_DIRECTIVES } from '@alfresco/adf-extensions';
import { DocumentListDirective } from '@adw/projects/aca-content/src/lib/directives/document-list.directive';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ContentModule,
    AppInfoDrawerModule,
    WkAppLayoutModule,
    WkDocumentListModule,
    ...CONTEXT_MENU_DIRECTIVES,
    LocationLinkComponent,
    SearchInputComponent,
    ToolbarActionComponent,
    ThumbnailColumnComponent,
    SearchActionMenuComponent,
    ToolbarComponent,
    ...EXTENSION_DIRECTIVES,
    ContextActionsDirective,
    DocumentListDirective,
  ],
  declarations: [WkSearchResultsComponent, WkSearchResultsRowComponent],
  exports: [WkSearchResultsComponent, WkSearchResultsRowComponent],
})
export class WkSearchResultsModule {}
